export default "__VITE_ASSET__927bc35e__"